import { Injectable } from '@angular/core';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { BaseDataResponse, BaseEntitiesResponse, BaseEntityResponse, NotificationDispatch, NotificationDispatchListParams, SendNotificationDispatchParams } from '@m4u-angular/base/entities/BaseEntities';
import { APIGatewayService } from '../gateway/APIGateway.service';
import { Observable } from 'rxjs';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';

@Injectable()
export class NotificationDispatchEndpoint extends BaseEndpointCRUD<NotificationDispatch> {
    constructor(api: APIGatewayService) {
        super('NotificationDispatch', api);
    }
    
    public GetNotificationDispatchesReport(Params: NotificationDispatchListParams, options: DataLoadOptions): Observable<BaseEntitiesResponse<NotificationDispatch>> {
        return this.api.ExecutePostAction(this.ControllerName, 'GetNotificationDispatchesReport', Params, options?.GetLoadOptions());
    }

    public SendNotificationDispatch(params: SendNotificationDispatchParams): Observable<BaseEntityResponse<NotificationDispatch>> {
        return this.api.ExecutePostAction(this.ControllerName, 'SendNotificationDispatch', params);
    }

    public  CancelPushNotification(NotificationDispatchID: number) : Observable<BaseDataResponse<boolean>> {
		return this.api.ExecutePostAction(this.ControllerName, 'CancelPushNotification', undefined,  { NotificationDispatchID: NotificationDispatchID } );
    }
}